"use strict";

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var operation_retrier_1 = require("operation-retrier");
/**
 * Retrier with backoff override capability
*/


var BackoffRetrier =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(BackoffRetrier, _events_1$EventEmitte);

  _createClass(BackoffRetrier, [{
    key: "inProgress",
    get: function get() {
      return !!this.retrier;
    }
  }]);

  function BackoffRetrier(options) {
    var _this;

    _classCallCheck(this, BackoffRetrier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BackoffRetrier).call(this));
    _this.options = options ? Object.assign({}, options) : {};
    return _this;
  }
  /**
   * Should be called once per attempt series to start retrier.
  */


  _createClass(BackoffRetrier, [{
    key: "start",
    value: function start() {
      if (this.inProgress) {
        throw new Error('Already waiting for next attempt, call finishAttempt(success : boolean) to finish it');
      }

      this.createRetrier();
    }
    /**
     * Should be called to stop retrier entirely.
    */

  }, {
    key: "stop",
    value: function stop() {
      this.cleanRetrier();
      this.newBackoff = null;
      this.usedBackoff = null;
    }
    /**
     * Modifies backoff for next attempt.
     * Expected behavior:
     * - If there was no backoff passed previously reschedulling next attempt to given backoff
     * - If previous backoff was longer then ignoring this one.
     * - If previous backoff was shorter then reschedulling with this one.
     * With or without backoff retrier will keep growing normally.
     * @param delay delay of next attempts in ms.
     */

  }, {
    key: "modifyBackoff",
    value: function modifyBackoff(delay) {
      this.newBackoff = delay;
    }
    /**
     * Mark last emmited attempt as failed, initiating either next of fail if limits were hit.
    */

  }, {
    key: "attemptFailed",
    value: function attemptFailed() {
      if (!this.inProgress) {
        throw new Error('No attempt is in progress');
      }

      if (this.newBackoff) {
        var shouldUseNewBackoff = !this.usedBackoff || this.usedBackoff < this.newBackoff;

        if (shouldUseNewBackoff) {
          this.createRetrier();
        } else {
          this.retrier.failed(new Error());
        }
      } else {
        this.retrier.failed(new Error());
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.retrier) {
        this.retrier.cancel();
      }
    }
  }, {
    key: "cleanRetrier",
    value: function cleanRetrier() {
      if (this.retrier) {
        this.retrier.removeAllListeners();
        this.retrier.cancel();
        this.retrier = null;
      }
    }
  }, {
    key: "getRetryPolicy",
    value: function getRetryPolicy() {
      var clone = Object.assign({}, this.options);

      if (this.newBackoff) {
        clone.min = this.newBackoff;
        clone.max = this.options.max && this.options.max > this.newBackoff ? this.options.max : this.newBackoff;
      } // As we're always skipping first attempt we should add one extra if limit is present


      clone.maxAttemptsCount = this.options.maxAttemptsCount ? this.options.maxAttemptsCount + 1 : undefined;
      return clone;
    }
  }, {
    key: "createRetrier",
    value: function createRetrier() {
      var _this2 = this;

      this.cleanRetrier();
      var retryPolicy = this.getRetryPolicy();
      this.retrier = new operation_retrier_1.Retrier(retryPolicy);
      this.retrier.once('attempt', function () {
        _this2.retrier.on('attempt', function () {
          return _this2.emit('attempt');
        });

        _this2.retrier.failed(new Error('Skipping first attempt'));
      });
      this.retrier.on('failed', function (err) {
        return _this2.emit('failed', err);
      });
      this.usedBackoff = this.newBackoff;
      this.newBackoff = null;
      this.retrier.start()["catch"](function (err) {});
    }
  }]);

  return BackoffRetrier;
}(events_1.EventEmitter);

exports.BackoffRetrier = BackoffRetrier;